module.exports = __webpack_public_path__ + "static/media/icon-x.1230c138.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-x.svg
// module id = 938
// module chunks = 0